import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { useCntfContent } from '~/composables/useCntfContent';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import { useSegment } from '~/composables/_next/useSegment';
import { useTrpc } from '~/composables/_next/useTrpc';
import Basic from '~/pages/legacy/Basic/Basic.vue';
import { cacheControl } from '~/helpers/cacheControl';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { useLocalization } from '~/composables/_next/useLocalization';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
export default defineComponent({
  components: {
    Basic: Basic
  },
  middleware: [cacheControl('public, s-maxage=7200, stale-while-revalidate=3600, stale-if-error=3600') // 2 hours cache and 1 hour stale
  ],
  tracking: {
    category: TrackingPageCategory.BASIC
  },
  setup: function setup() {
    var _useTrpc = useTrpc(),
      client = _useTrpc.client;
    var route = useRoute();
    var _useCntfContent = useCntfContent('pageBasic'),
      search = _useCntfContent.search,
      content = _useCntfContent.content,
      loading = _useCntfContent.loading;
    var _useNuxt2App = useNuxt2App(),
      error = _useNuxt2App.error;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta,
      getMeta = _useLegacySeoMeta.getMeta;
    var _useSlug = useSlug(),
      transformSlugsForSeo = _useSlug.transformSlugsForSeo;
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR;

    // TODO: Remove after Nuxt 3 migration
    onMounted(function () {
      var _useSegment = useSegment(),
        trackPage = _useSegment.trackPage;
      trackPage(TrackingPageCategory.BASIC, PageTypes.BASIC);
    });
    var contentResource = useState('basic-content', function () {});
    var tabs = useState('basic-tabs', function () {
      return null;
    });
    var entryId = useState('basic-entry-id', function () {
      return null;
    });
    provide('isFullWidth', true);
    var pageBasicData = useState("page-basic-".concat(route.params.slug), function () {});
    useLazyAsyncData('basic-index', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _content$value, _content$value$, _content$value$$sys, _content$value2, _content$value2$, _content$value3, _content$value3$, _content$value4, _content$value4$, _content$value4$$fiel, _content$value4$$fiel2, _pageBasicData$value, _pageBasicData$value$, _pageBasicData$value$2;
      var seo;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.contentful.getPageBasic.query({
              slug: route.params.slug,
              locale: locale
            });
          case 2:
            pageBasicData.value = _context.sent;
            _context.next = 5;
            return search({
              'content_type': 'pageBasic',
              'fields.slug': route.params.slug
            }, ['blocs']);
          case 5:
            entryId.value = (_content$value = content.value) === null || _content$value === void 0 ? void 0 : (_content$value$ = _content$value[0]) === null || _content$value$ === void 0 ? void 0 : (_content$value$$sys = _content$value$.sys) === null || _content$value$$sys === void 0 ? void 0 : _content$value$$sys.id;
            contentResource.value = (_content$value2 = content.value) === null || _content$value2 === void 0 ? void 0 : (_content$value2$ = _content$value2[0]) === null || _content$value2$ === void 0 ? void 0 : _content$value2$.fields;
            tabs.value = (_content$value3 = content.value) === null || _content$value3 === void 0 ? void 0 : (_content$value3$ = _content$value3[0]) === null || _content$value3$ === void 0 ? void 0 : _content$value3$.fields.blocs;
            if (contentResource.value) {
              _context.next = 11;
              break;
            }
            error({
              statusCode: 404
            });
            return _context.abrupt("return", true);
          case 11:
            seo = Object.assign({}, (_content$value4 = content.value) === null || _content$value4 === void 0 ? void 0 : (_content$value4$ = _content$value4[0]) === null || _content$value4$ === void 0 ? void 0 : (_content$value4$$fiel = _content$value4$.fields) === null || _content$value4$$fiel === void 0 ? void 0 : (_content$value4$$fiel2 = _content$value4$$fiel.seo) === null || _content$value4$$fiel2 === void 0 ? void 0 : _content$value4$$fiel2.fields, {
              slug: transformSlugsForSeo(pageBasicData === null || pageBasicData === void 0 ? void 0 : (_pageBasicData$value = pageBasicData.value) === null || _pageBasicData$value === void 0 ? void 0 : (_pageBasicData$value$ = _pageBasicData$value.data) === null || _pageBasicData$value$ === void 0 ? void 0 : (_pageBasicData$value$2 = _pageBasicData$value$.pageBasicCollection) === null || _pageBasicData$value$2 === void 0 ? void 0 : _pageBasicData$value$2.items[0])
            });
            setMeta(seo);
            return _context.abrupt("return", true);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onMounted(function () {
      setDynamicYieldContext('OTHER', ['Basic_Page']);
    });
    setDynamicYieldContextSSR('OTHER', ['Basic_Page']);
    return {
      getMeta: getMeta,
      contentResource: contentResource,
      tabs: tabs,
      loading: loading
    };
  }
});